// extracted by mini-css-extract-plugin
module.exports = {"select":"record-per-page_select__1vSFi","focus-visible":"record-per-page_focus-visible__hEZ8b","container":"record-per-page_container__9jJA0","text":"record-per-page_text___xqfM"};